import { RouteNames } from '@/models/enums/RouteNames';
import { Role } from '@sysarb/sysarb-types/service-base/enums';
import type { RouteRecordRaw } from 'vue-router';

export const dataImportRoutes: RouteRecordRaw[] = [
    {
        path: '', // select if you want file or integration
        name: RouteNames.AdministratorDataImport,
        component: async () => import('@/views/dataImport/DataImport.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            userTypes: [Role.Administrator, Role.Root, Role.SystemAdministrator, Role.Consultant]
        },
    },
    {
        path: 'file-import', // file import overview
        name: RouteNames.AdministratorSalaryImport,
        component: async () => import('@/views/dataImport/salaryFileImport/SalaryFileOverview.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            userTypes: [Role.Administrator, Role.Root, Role.SystemAdministrator, Role.Consultant]
        },
    },
    {
        path: 'file-import-details', // file import details
        name: RouteNames.AdministratorSalaryImportSettings,
        component: async () => import('@/views/dataImport/salaryFileImport/SalaryFileImport.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            userTypes: [Role.Administrator, Role.Root, Role.SystemAdministrator, Role.Consultant]
        },
    },
    {
        path: 'integrations', // create integration
        name: RouteNames.AdministratorIntegrationList,
        component: async () => import('@/views/dataImport/integration/IntegrationList.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            userTypes: [Role.Administrator, Role.Root, Role.SystemAdministrator, Role.Consultant]
        },
    },
    {
        path: 'integrations/:name/integration-type', // select integration type
        name: RouteNames.AdministratorIntegrationType,
        component: async () => import('@/views/dataImport/integration/IntegrationSelectType.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            userTypes: [Role.Administrator, Role.Root, Role.SystemAdministrator, Role.Consultant]
        },
    },
    {
        path: 'integration', // list all created integrations
        name: RouteNames.AdministratorIntegrationOverview,
        component: async () => import('@/views/dataImport/integration/IntegrationOverview.vue'),
        props: false,
        meta: {
            requiresAuth: true,
            userTypes: [Role.Administrator, Role.Root, Role.SystemAdministrator, Role.Consultant]
        }
    },
    {
        path: 'integration/:id',
        component: async () => import('@/views/dataImport/integration/Integration.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            userTypes: [Role.Administrator, Role.Root, Role.SystemAdministrator, Role.Consultant]
        },
        children: [
            {
                path: 'filter', // configure a specific integration
                name: RouteNames.AdministratorIntegrationFilter,
                component: async () => import('@/views/dataImport/integration/IntegrationFilters.vue'),
                props: true,
                meta: {
                    requiresAuth: true,
                    userTypes: [Role.Administrator, Role.Root, Role.SystemAdministrator, Role.Consultant]
                },
            },
            {
                path: 'setup', // configure a specific integration
                name: RouteNames.AdministratorIntegrationSetup,
                component: async () => import('@/views/dataImport/integration/IntegrationSetup.vue'),
                props: true,
                meta: {
                    requiresAuth: true,
                    userTypes: [Role.Administrator, Role.Root, Role.SystemAdministrator, Role.Consultant]
                },
            },
            {
                path: 'preview', // preview data from a specific integration
                name: RouteNames.AdministratorIntegrationPreview,
                component: async () => import('@/views/dataImport/integration/IntegrationPreview.vue'),
                props: true,
                meta: {
                    requiresAuth: true,
                    userTypes: [Role.Administrator, Role.Root, Role.SystemAdministrator, Role.Consultant]
                },
            },
            {
                path: 'validation', // validate data from a specific integration
                name: RouteNames.AdministratorIntegrationValidation,
                component: async () => import('@/views/dataImport/integration/IntegrationValidation.vue'),
                props: true,
                meta: {
                    requiresAuth: true,
                    userTypes: [Role.Administrator, Role.Root, Role.SystemAdministrator, Role.Consultant]
                },
            },
            {
                path: 'match-fields', // match fields from a specific integration
                name: RouteNames.AdministratorIntegrationMatchFields,
                component: async () => import('@/views/dataImport/integration/IntegrationFieldMappings.vue'),
                props: true,
                meta: {
                    requiresAuth: true,
                    userTypes: [Role.Administrator, Role.Root, Role.SystemAdministrator, Role.Consultant]
                },
            }
        ]
    },
];
